import { connect } from 'react-redux';
import { Action } from 'redux';

import { ServiceLocator } from '../../app/ServiceLocator';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';

import { SessionSiteSelectors, SessionUserSelectors } from '../../app/selectors/SessionInfoSelectors';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { HelpService } from '../../ts/services/HelpService';
import { ServerService } from '../../ts/services/ServerService';
import { homeCloseWelcomeScreenAction } from '../actions/HomeActions';
import { WelcomeScreenPropsByRole } from '../utils/WelcomeScreenPropsByRole';
import { WelcomeScreen, WelcomeScreenDispatchProps, WelcomeScreenStateProps } from './WelcomeScreen';

export const mapStateToProps: MapStateToProps<WelcomeScreenStateProps> = (state: AppState) => {

  const siteUrls = new SpacesSiteUrls({
    siteUrlName: ServiceLocator.get<ServerService>('ServerService').sessionSiteUrlName(),
  });

  const isWebAuthoringEnabled = SessionUserSelectors.canAuthorOnWeb(state);
  const welcomeScreenPropsByRole = new WelcomeScreenPropsByRole(siteUrls, ServiceLocator.get<HelpService>('HelpService'));
  const userRole = getRole(state);

  return welcomeScreenPropsByRole.getProps(userRole, isWebAuthoringEnabled);
};

export const mapDispatchToProps: MapDispatchToProps<WelcomeScreenDispatchProps> = (dispatch) => ({
  closeWelcomeScreen: () => {
    dispatch(homeCloseWelcomeScreenAction());
  },
  dispatchAction: (action: Action) => dispatch(action)
});

/**
 * Some logic to account for weird behavior where Server Admins have a "Creator" role from getSessionInfo.
 */
function getRole(state: AppState): string {
  if (SessionUserSelectors.isSessionServerAdmin(state)) {
    return SiteRoles.ServerAdministrator;
  } else {
    return SessionSiteSelectors.siteRole(state);
  }
}

export const ConnectedWelcomeScreen = connect(mapStateToProps, mapDispatchToProps)(WelcomeScreen);
